import Button from '../../../../components/ui/Button';

/**
 * Edit team member modal. useForm lives in the parent (Team.jsx);
 * registerEdit and handleEditSubmit are passed as props — matching the
 * SiteFormModal pattern.
 */
export default function TeamEditModal({
  onClose,
  registerEdit,
  handleEditSubmit,
  onEditSubmit,
  updateUserMutation,
  roleOptions,
}) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal team-invite-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Edit Team Member</h2>
        <form onSubmit={handleEditSubmit(onEditSubmit)} className="team-invite-form">
          <div className="form-row">
            <div className="form-group">
              <label>First name</label>
              <input
                type="text"
                {...registerEdit('firstName', { required: 'First name is required' })}
                className="form-control team-input-thumb"
              />
            </div>
            <div className="form-group">
              <label>Last name</label>
              <input
                type="text"
                {...registerEdit('lastName', { required: 'Last name is required' })}
                className="form-control team-input-thumb"
              />
            </div>
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              {...registerEdit('email', {
                required: 'Email is required',
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Enter a valid email address',
                },
              })}
              className="form-control team-input-thumb"
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label>Role</label>
            <select {...registerEdit('role')} className="form-control team-input-thumb">
              {roleOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="form-check-label" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
              <input type="checkbox" {...registerEdit('mustChangePassword')} />
              Require password change on next login
            </label>
          </div>
          <div className="form-actions">
            <Button
              type="button"
              className="team-btn-thumb"
              onClick={onClose}
              disabled={updateUserMutation.isLoading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              className="team-btn-thumb"
              disabled={updateUserMutation.isLoading}
            >
              {updateUserMutation.isLoading ? 'Saving…' : 'Save changes'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
